package com.gloopgo.game.network

import dev.gitlive.firebase.database.ServerValue
import kotlinx.serialization.Serializable

@Serializable
data class PlayerReportRecord(
    val reporterUid: String = "",
    val reportedUid: String = "",
    val reportedNickname: String = "",
    val reason: String = "",
    val createdAt: ServerValue = ServerValue.TIMESTAMP
)

@Serializable
data class PlayerBlockRecord(
    val nickname: String = "",
    val blockedAt: ServerValue = ServerValue.TIMESTAMP
)
